import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { Fragment, useContext } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import TulipIcon from '../../../assets/tulip.svg';
import Button from '../../../components/Button';
import DefaultCard from '../../../components/DefaultCard';
import GenericCard from '../../../components/GenericCards';
import { AuthStore } from '../../../providers/auth';
import { HssProvider } from '../../../providers/hss';
import {
  addOrRemoveDaysToGivenDate,
  addOrRemoveYearsToGivenDate,
  DateFormats,
  formatDate,
  formatPrice,
  openExternalLink,
} from '../../../utils/utils';

function HealthSavingsAndSpendingChannelInactivView() {
  const [,] = useContext(AuthStore) || [];
  const date = new Date();

  return (
    <Container className={'cnd-custom-container-large mb-12 px-lg-9 px-xl-0'}>
      <Row className={'mt-7 mt-lg-13'}>
        <Col
          sm={12}
          lg={8}
          className={
            'd-flex justify-content-between align-items-center pt-lg-8'
          }
        >
          <h6 className={'h6 fw-normal mb-0'}>
            {'Health Reimbursement Arrangement (HRA)'}
          </h6>
          <Button
            variant="primary-outline"
            rightIcon={light('chevron-right')}
            size="sm"
            onClick={() => {
              openExternalLink('https://app.teamwalnut.com/player/?demoId=e9baf7b9-ac3d-4400-8a96-898d04a45259&showGuide=true&showGuidesToolbar=true&showHotspots=true&source=app');
            }}
          >
            Details
          </Button>
        </Col>
      </Row>
      <Row className={'mt-10'}>
        <Col sm={12} lg={8}>
          <GenericCard variant="white" style={{ zIndex: '1000' }}>
            <Row>
              <Col className={'col-12'}>
                <h4 className={'text-sm-24-lg-32'}>{'Account'}</h4>
              </Col>

              <Col className={'mt-3 col-12'}>
                <span
                  className={'text-fs-6 fw-light lh-xxs text-dark-gray'}
                >{`As of ${formatDate(date)}`}</span>
              </Col>
            </Row>

            <Row className={'py-3 mt-7 mx-0 border-bottom-light-gray-2px'}>
              <Col className={'ps-0 col-8'}>
                <span className={'text-fs-6 lh-xxs fw-normal text-dark-gray'}>
                  Period
                </span>
              </Col>
              <Col className={'col-2 text-end'}>
                <span className={'text-fs-6 lh-xxs fw-light text-ligther-grey'}>
                  Total
                </span>
              </Col>
              <Col className={'pe-0 col-2 text-end'}>
                <span className={'text-fs-6 lh-xxs fw-light text-ligther-grey'}>
                  Available
                </span>
              </Col>
            </Row>

            <Row className={'mx-0 py-3 border-bottom-light-gray-lg'}>
              <Col className={'ps-0 col-8'}>
                <span className={'text-fs-6 lh-xxs fw-normal text-dark-gray'}>
                  {`${date.getFullYear()} Plan Year `}
                  <span
                    className={'text-fs-6 lh-xxs fw-light text-ligther-grey'}
                  >
                    {`(${formatDate(
                      new Date(date.getFullYear(), 0, 1),
                      DateFormats.US
                    )} - ${formatDate(
                      new Date(date.getFullYear(), 11, 31),
                      DateFormats.US
                    )})`}
                  </span>
                </span>
              </Col>

              <Col className={'col-2 text-end'}>
                <span className={'text-fs-6 lh-xxs fw-normal text-dark-gray'}>
                  $500.00
                </span>
              </Col>

              <Col className={'pe-0 col-2 text-end'}>
                <span className={'text-fs-6 lh-xxs fw-normal text-dark-gray'}>
                  $500.00
                </span>
              </Col>
            </Row>

            <Row className={'mx-0 py-3'}>
              <Col className={'ps-0 col-8'}>
                <span className={'text-fs-6 lh-xxs fw-normal text-dark-gray'}>
                  {`${date.getFullYear() - 1} Plan Year `}
                  <span
                    className={'text-fs-6 lh-xxs fw-light text-ligther-grey'}
                  >
                    {`(${formatDate(
                      new Date(date.getFullYear() - 1, 0, 1),
                      DateFormats.US
                    )} - ${formatDate(
                      new Date(date.getFullYear() - 1, 11, 31),
                      DateFormats.US
                    )})`}
                  </span>
                </span>
              </Col>

              <Col className={'col-2 text-end'}>
                <span className={'text-fs-6 lh-xxs fw-normal text-dark-gray'}>
                  $500.00
                </span>
              </Col>

              <Col className={'pe-0 col-2 text-end'}>
                <span className={'text-fs-6 lh-xxs fw-normal text-dark-gray'}>
                  $0.00
                </span>
              </Col>
            </Row>
          </GenericCard>
        </Col>
        <Col sm={12} lg={4} className={'mt-11 mt-lg-0'}>
          <Card
            key={'Card1'}
            className={'item-col mt-10 p-5 pb-7 rounded-1 col-12'}
            onClick={() => {
              openExternalLink('https://app.teamwalnut.com/player/?demoId=e9baf7b9-ac3d-4400-8a96-898d04a45259&showGuide=true&showGuidesToolbar=true&showHotspots=true&source=app');
            }}
          >
            <section style={{ background: 'white' }}>
              <div className={'carousel-img-container'}>
                <img
                  className={'w-100 h-auto'}
                  src={`${process.env.PUBLIC_URL}/company11.png`}
                  alt={`${process.env.PUBLIC_URL}/company11.png`}
                  style={{ width: '100%' }}
                />
              </div>
              <div className='mt-4 lh-xs fw-light'>
                <h6 className='mb-0 text-sm-16-lg-20'>HealthEquity</h6>
              </div>
              <div className='lh-xxs fw-light text-sub1 text-light-grey-normal'>
                <span>View balances, claims, eligible expenses &amp; more</span>
              </div>
            </section>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

function HealthSavingsAndSpendingChannelInactive() {
  return (
    <HssProvider>
      <HealthSavingsAndSpendingChannelInactivView />
    </HssProvider>
  );
}

export default HealthSavingsAndSpendingChannelInactive;
